import { IPrismicRichText } from '@monofront/types';
import { RichText } from 'prismic-reactjs';
import CustomPrismicLink from '@components/CustomPrismicLink';

interface IApproachContainerCard {
  title: IPrismicRichText;
  largeTitle: boolean;
  text: IPrismicRichText;
}

export const ApproachContainerCard: React.FC<IApproachContainerCard> = ({
  title,
  largeTitle,
  text,
}) => (
  <div className="container-card">
    <div className="card-approach tw-rounded-2xl tw-bg-white">
      <div className={`${largeTitle ? 'large-title' : ''} title`}>
        <RichText render={title} />
      </div>
      <RichText serializeHyperLink={CustomPrismicLink} render={text} />
    </div>
    <style jsx>{`
      .large-title > :global(h1) {
        font-size: var(--text-size-large-h1);
        line-height: 66px;
      }

      .title > :global(*) {
        margin-bottom: var(--space-4);
      }

      .card-approach > :global(p) > :global(a) {
        color: var(--clr-link);
        text-decoration: underline;
      }

      .card-approach > :global(p) > :global(a):hover {
        opacity: var(--opacity-link-hover);
      }

      .container-card {
        flex: 0 1 60%;
        position: relative;
        width: 90%;
        overflow: unset;
      }

      .card-approach {
        padding: 50px 88px;
        margin: 0 auto;
      }

      .card-approach > :global(h1) {
        margin-bottom: 20px;
      }

      .card-approach > :global(p) {
        margin-bottom: var(--space-3);
      }

      .card-approach > :global(p:last-child) {
        margin-bottom: 0;
      }

      @media (max-width: 800px) {
        .large-title :global(h1) {
          margin-bottom: 16px;
          font-size: var(--text-size-h1);
          line-height: 1.375;
        }

        .container-card {
          order: 2;
          margin-top: -80px;
          width: calc(100% - 35px);
        }

        .card-approach {
          padding: 18px;
        }
      }
    `}</style>
  </div>
);
